'use client';

import { AnimatePresence } from '@scatterlab/zeta-core';
import { memo, useLayoutEffect, useState } from 'react';

import Popup from './Popup';
import PopupController, { PopupItem } from './PopupController';
import useOverflowHidden from '../hooks/useOverflowHidden';

const PopupContainer = () => {
  const [popups, setPopups] = useState<PopupItem[]>([]);

  useLayoutEffect(() => {
    const removeShowListener = PopupController.addListener(
      'show',
      (newPopup) => {
        setPopups((prevPopups) => [...prevPopups, newPopup]);
      },
    );

    const removeHideListener = PopupController.addListener(
      'hide',
      (targetId) => {
        setPopups((prevPopups) =>
          prevPopups.filter((popup) => popup.id !== targetId),
        );
      },
    );

    return () => {
      removeShowListener();
      removeHideListener();
    };
  }, []);

  useOverflowHidden(popups.length > 0);

  return (
    <AnimatePresence>
      {popups.map((popup) => (
        <Popup key={popup.id} {...popup} />
      ))}
    </AnimatePresence>
  );
};

export default memo(PopupContainer);
